import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import MessageBoard from './MessageBoard';
import './PostDetail.css';
import RingLoader from "react-spinners/RingLoader";

const PostDetail = () => {
  const { id: postId } = useParams();
  const [postData, setPostData] = useState(null);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        // Fetch post detail from mobile endpoint (returns location info)
        const res = await axiosInstance.get(`/messageboard/mobile/post/${postId}/club/`);
        setPostData(res.data);

        // Also try to load course details for additional context
        if (res.data?.location?.course_id) {
          try {
            const courseRes = await axiosInstance.get(`/courses/${res.data.location.course_id}/`);
            setCourse(courseRes.data);
          } catch (e) {
            // Course details optional
          }
        }
      } catch (error) {
        // Fallback: try legacy endpoint
        try {
          const postResponse = await axiosInstance.get(`/messageboard//post/${postId}/course/`);
          const courseId = postResponse.data.course_id;
          const courseResponse = await axiosInstance.get(`/courses/${courseId}/`);
          setCourse(courseResponse.data);
        } catch (e) {
          console.error('Error fetching post details:', e);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPostDetails();
  }, [postId]);

  const clubName = postData?.location?.club_name || course?.golf_course;
  const clubSlug = postData?.location?.club_slug;
  const clubId = postData?.location?.club_id;
  const clubCity = postData?.location?.city || course?.city;
  const clubState = postData?.location?.state || course?.state;
  const clubLink = clubSlug ? `/club/${clubSlug}` : (clubId ? `/club/${clubId}` : null);

  return (
    <div className="course-detail">
      {loading ? (
        <div className="loading-spinner-post">
          <RingLoader />
        </div>
      ) : (
        <>
          {clubName && (
            <div className="pd-club-card">
              <div className="pd-club-info">
                {clubLink ? (
                  <Link to={clubLink} className="pd-club-name">{clubName}</Link>
                ) : (
                  <span className="pd-club-name">{clubName}</span>
                )}
                {(clubCity || clubState) && (
                  <span className="pd-club-location">{[clubCity, clubState].filter(Boolean).join(', ')}</span>
                )}
              </div>
              {clubLink && (
                <Link to={clubLink} className="pd-view-club">View Club →</Link>
              )}
            </div>
          )}
          <div className="messageboard-container-post">
            <MessageBoard postId={parseInt(postId, 10)} />
          </div>
        </>
      )}
    </div>
  );
};

export default PostDetail;